import React from "react";
import Icon from "./Icon";

export default function EmptyState({ icon = "inbox", title, text, action }) {
    return (
        <div className="empty-state">
            <span className="empty-icon">
                <Icon name={icon} size={24} />
            </span>
            {title && <p className="empty-title">{title}</p>}
            {text && <p className="empty-text">{text}</p>}
            {action}
        </div>
    );
}
